import React, { useState, useEffect } from 'react';

import { Form, Button, Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';

import ServiceService from 'Services/ServiceService';
import DepartementService from 'Services/DepartementService';
import { Formik } from 'formik';
import * as yup from 'yup';

import { nullToEmptyStringOrDefault } from 'Utils/Helpers';

const schema = yup.object({
    nom: yup.string().required(),
    codeInterne: yup.string().required(),
    departementId: yup.number().required(),
});

const CreateOrEdit = (props) => {
    const history = useHistory();

    const [service, setService] = useState(null);
    const [departements, setDepartements] = useState([]);

    const {
        match: { params },
    } = props;

    useEffect(() => {
        DepartementService.getDepartements()
            .then((result) => {
                if (result.status === 200) {
                    setDepartements(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });

        if (params.serviceId) {
            ServiceService.getServiceById(params.serviceId)
                .then((result) => {
                    if (result.status === 200) {
                        setService(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params]);

    const submitForm = (data) => {
        ServiceService.saveService({ serviceId: params.serviceId, ...data })
            .then((result) => {
                // console.log(result.data);
                if (result.status === 200) {
                    history.push('/admin/service/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    Home
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
                    Admin
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin/service/index' }}>
                    Services
                </Breadcrumb.Item>
                <Breadcrumb.Item active>{params.serviceId ? 'Edit Service' : 'Create New Service'}</Breadcrumb.Item>
            </Breadcrumb>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">{params.serviceId ? 'Edit Service' : 'Create New Service'}</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{params.serviceId}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                    <Formik
                        validationSchema={schema}
                        onSubmit={(values) => submitForm(values)}
                        enableReinitialize={true}
                        initialValues={{
                            nom: service ? service.nom : '',
                            codeInterne: service ? service.codeInterne : '',
                            departementId:
                                service && service.departementId
                                    ? nullToEmptyStringOrDefault(service.departementId)
                                    : '',
                        }}
                    >
                        {({ handleSubmit, values, errors, handleChange }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Nom</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Nom"
                                        name="nom"
                                        value={values.nom}
                                        onChange={handleChange}
                                        isInvalid={!!errors.nom}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>CodeInterne</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="CodeInterne"
                                        name="codeInterne"
                                        value={values.codeInterne}
                                        onChange={handleChange}
                                        isInvalid={!!errors.codeInterne}
                                    />
                                </Form.Group>
                                <Form.Group controlId="exampleForm.departements">
                                    <Form.Label>Departement</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="departementId"
                                        value={values.departementId}
                                        isInvalid={!!errors.departementId}
                                        onChange={handleChange}
                                    >
                                        <option value="">Selectionner une departement</option>
                                        {departements.map((departementData, i) => (
                                            <option key={i} value={departementData.departementId}>
                                                {departementData.nom}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                                <Button variant="primary" type="submit" block>
                                    Submit
                                </Button>
                            </Form>
                        )}
                    </Formik>
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default CreateOrEdit;
